import { usePathname } from 'next/navigation'
import React from 'react'

export const useScrollTop = () => {
    const pathname = usePathname() // Получаем путь через usePathname
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [pathname])
}
